import { render } from "./FirstDeployment.vue?vue&type=template&id=1c9cec10&scoped=true"
import script from "./FirstDeployment.vue?vue&type=script&lang=js"
export * from "./FirstDeployment.vue?vue&type=script&lang=js"

import "./FirstDeployment.vue?vue&type=style&index=0&id=1c9cec10&scoped=true&lang=css"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9cec10"]])

export default __exports__